import { render, staticRenderFns } from "./TransferAppointmentsModal.vue?vue&type=template&id=187d73df"
import script from "./TransferAppointmentsModal.vue?vue&type=script&lang=js"
export * from "./TransferAppointmentsModal.vue?vue&type=script&lang=js"
import style0 from "./TransferAppointmentsModal.vue?vue&type=style&index=0&id=187d73df&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports